// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay div.price p{color:#404040;margin-bottom:.25rem}#openbay div.price p .join-plus-price{font-size:16px}#openbay div.price p span{font-size:1.125rem;font-weight:700}#openbay div.price p span.price-list{font-size:.875rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
